import { AxiosRequestConfig } from 'axios';

import { PaginationData, PaginationPcApiResponse } from '@/api/pc-api/types';
import { BizTargetType } from '@/constants/bizTargetType';
import { BizType } from '@/constants/bizType';
import { PartnerRegStatus } from '@/constants/partnerRegStatus';
import { Role } from '@/constants/role';
import { api } from '@/utils/api';

export type DashbaordMyBizItem = {
  dealerId?: string;
  dealerCompanyName?: string;
  partnerId?: string;
  partnerCompanyName?: string;
  authInfoId: string;
  role: Role;
  bizTargetType: BizTargetType;
  partnerRegStatus?: PartnerRegStatus;
  bizType: BizType;
};

export type DashbaordPaginationResponse = PaginationPcApiResponse<DashbaordMyBizItem[]>;
export type DashbaordPagination = PaginationData<DashbaordMyBizItem[]>;

type Params = {
  companyName: string;
  page: number;
  size?: number;
  options?: AxiosRequestConfig;
};

const DEFAULT_PAGE_SIZE = 10;
export const getMybizDashboard = ({ companyName, page, size = DEFAULT_PAGE_SIZE, options }: Params) => {
  return api<PaginationPcApiResponse<DashbaordMyBizItem[]>>(
    'get',
    '/pc-api/v1/mybiz/list/dashboard',
    { companyName, page, size },
    options
  );
};
